module.exports = __webpack_public_path__ + "media/images/correct-d956a5a48ae829dc9c17f4f247d2a47f.svg";